if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.recommendProdCards = document.querySelector(
          ".product-detail-header product-add-card-container"
        );
        // this.addRecommendProdTogether();

        this.listenerAddCartButton();
      }

      listenerAddCartButton() {
        const button_checkbox = document.querySelector(
          "#product-add-cart--button-checkbox"
        );
        if (!button_checkbox) return;
        const cartContent = document.querySelector(
          ".product-add-cart-checkbox"
        );
        const error_message = document.querySelector(
          ".product-add-cart--error-message"
        );
        const card_mask = document.querySelectorAll(
          ".payment-buttons-card--mask"
        );
        button_checkbox.addEventListener("change", (e) => {
          if (e.target.checked) {
            $(card_mask).addClass("hidden");
            error_message.classList.remove("open");
          } else {
            $(card_mask).removeClass("hidden");
          }
        });

        const cart_modal = document.querySelector(".product-add-cart--modal");
        const cart_label = document.querySelector("#product-add-cart--label");
        const handleA = cart_label.querySelector("a");
        if (handleA) {
          handleA.onclick = (e) => {
            e.preventDefault();
            cart_modal.classList.add("open");
          };

          cart_modal
            .querySelector(".product-add-cart--close")
            .addEventListener("click", () => {
              cart_modal.classList.remove("open");
            });
        }

        let time = 0;
        $(card_mask).on("click", function () {
          error_message.classList.add("shake");
          error_message.classList.add("open");
          cartContent.scrollIntoView({ behavior: "smooth" });
          if (time) {
            clearTimeout(time);
          }
          time = setTimeout(() => {
            error_message.classList.remove("shake");
          }, 500);
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const recommendProducts =
          this.recommendProdCards?.getRecommandedProducts();
        this.handleAddRequest(recommendProducts);
        // this.handleAddRequest();
      }

      handleAddRequest(extraProducts) {
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        // delete config.headers['Content-Type'];

        config.body = this.getFormJsonData(extraProducts);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getFormJsonData(extraProducts = []) {
        let formJsonData = {};
        const formData = new FormData(this.form);
        const formObject = Object.fromEntries(formData);
        const formDataItems = [formObject, ...extraProducts];
        formJsonData = { items: formDataItems };
        if (this.cart) {
          formJsonData = {
            ...formJsonData,
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
          };
          formJsonData = {
            ...formJsonData,
            sections_url: window.location.pathname,
          };
          this.cart.setActiveElement(document.activeElement);
        }
        return JSON.stringify(formJsonData);
      }

      addRecommendProdTogether() {
        document.querySelectorAll(".product-add-card").forEach((el) => {
          if (el) {
            var id = el.querySelector('[data-id="id"]')?.value;
            if (id !== undefined) {
              const productData = {
                form_type: "product",
                utf8: "✓",
                id,
                quantity: 1,
              };
              el.querySelector(".pac-add-together-btn").addEventListener(
                "click",
                () => {
                  this.handleAddRequest([productData]);
                }
              );
            }
          }
        });
      }
    }
  );
}
